import module from 'fan/proyecto/module.js'
import template from './template.html'
import { FanProyectoConfiguracionFactorService } from '../../../../services/Proyecto/Configuracion/Factor'

export class FanProyectoConfiguracionFactorEditarComponent {
  constructor(FanProyectoConfiguracionFactorService) {
    this.fanProyectoConfiguracionFactorService = FanProyectoConfiguracionFactorService
    this.idProyecto = undefined
    this.onChange = undefined
    this.onClose = undefined
    this.factor = null
  }

  $onInit() {

  }

  cancelar() {
    this.onClose()
  }

  actualizar() {
    this.actualizando = true

    let body = {
      factor: this.factor / 100,
    }

    return this.fanProyectoConfiguracionFactorService.put(this.idProyecto, body)
      .then(({data}) => {
        data.factor = data.factor * 100
        this.data = data

        this.onChange({$event: {data: this.data}})
        this.onClose()

      })
      .finally(() => (this.actualizando = false))
  }
}

module.component('fanProyectoConfigFactorEditar', {
  controller: FanProyectoConfiguracionFactorEditarComponent,
  template: template,
  bindings: {
    idProyecto: '<',
    factor: '<',
    onChange: '&',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/configuracion/factor/editar/component.js